export enum TypeTimeReports {
    DAILY       = 'daily',
    WEEKLY      = 'weekly',
    MONTHLY     = 'monthly',
}

export enum ColumnType {
    TOTAL_FOR_DATE_RANGE    = "Total Reported",
    REQUIRED_REPORT         = "Required Report",
    WORKDAYS                = "Workdays",
    OFF_DAYS                = "Off-days"
}

// REQUIRED_REPORT - do not use it for now (!) just comment maybe we'll need it in the future
// Total reported - total hours reported for current date range
// Total required - total hours required for current date range
// Workdays       - total number of work days for this user
// Off-days       - total number of non workiking days
